import * as React from "react";
import {Component} from "react";

import {observer} from "mobx-react";
import {Message} from "semantic-ui-react";

import "./project-id-hints.scss";

import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";

export interface ProjectIdHintsProps {
    auftragsverwaltung: Auftragsverwaltung;
    filteredProjectIds: number[]; // the part of the project ID already typed in input field
    projectIdMatch?: number;  // an existing project id that matches the ID specified in input field
}

@observer
export class ProjectIdHints extends Component<ProjectIdHintsProps, any> {

    constructor(props: ProjectIdHintsProps) {
        super(props);
        this.state = {};
    }

    componentDidMount(): void {}

    componentWillUnmount(): void {}

    render(): React.ReactElement | null {
        const {filteredProjectIds, projectIdMatch} = this.props;

        const idElements = filteredProjectIds.map((id) => {
            const isMatch = projectIdMatch === id;
            return <span key={id} className={isMatch ? "match" : undefined}>{id}</span>;
        });

        return(
            <>
                {filteredProjectIds && filteredProjectIds.length > 0 &&
                    <Message
                        className="project-id-hints"
                        attached
                        info
                        size="mini"
                        header="Vorangegangene Projektnummern"
                        content={<div className="piped">{idElements}</div>}
                    />
                }
            </>
        );
    }

}
